module.exports = __webpack_public_path__ + "media/images/icons/outlined/mobile-9cb01148ea72bc11165a7056b047a46c.svg";